/**
 * Fired on `window` whenever a funnel page's content becomes visible: on every
 * PageTransition mount (the URL commits before slow pages finish rendering)
 * and when the /prepackages fake pricing loader ends. Consumers (SMQ v2
 * auto-open) use it to count "time spent on the page" from what the user
 * actually sees rather than from the URL change.
 */
export const PAGE_SHOWN_EVENT = "dalma:page-shown"

export function notifyPageShown() {
  window.dispatchEvent(new Event(PAGE_SHOWN_EVENT))
}
